(function() { module.exports = window["interact"]; }());